"use client";

import { ArrowRight, Play } from "lucide-react";

import { useUser } from "@/hooks/useUser";
import { Button } from "@/lib/components/button";
import { useAppConfig } from "@/lib/config";

import { useI18n } from "@llmgateway/i18n/react";

export function ModelCtaButton({
	modelId,
	output,
	size = "default",
	className = "w-full gap-2 font-semibold group/cta",
	iconClassName = "h-4 w-4 transition-transform group-hover/cta:translate-x-0.5",
	onClick,
}: {
	modelId: string;
	output?: readonly string[] | null;
	size?: "default" | "sm";
	className?: string;
	iconClassName?: string;
	onClick?: (e: React.MouseEvent) => void;
}) {
	const { t } = useI18n();
	const config = useAppConfig();
	const { user, isLoading } = useUser();
	const isLoggedIn = !!user && !isLoading;

	if (isLoggedIn) {
		const studioPath = output?.includes("video")
			? "/video"
			: output?.includes("image")
				? "/image"
				: "";
		return (
			<Button
				variant="default"
				size={size}
				className={className}
				onClick={onClick}
				asChild
			>
				<a
					href={`${config.playgroundUrl}${studioPath}?model=${encodeURIComponent(modelId)}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					<Play className={iconClassName} />
					{t("public.common.tryInPlayground")}
				</a>
			</Button>
		);
	}

	return (
		<Button
			variant="default"
			size={size}
			className={className}
			onClick={onClick}
			asChild
		>
			<a href={`${config.appUrl}/signup`}>
				{t("public.common.getStarted")}
				<ArrowRight className={iconClassName} />
			</a>
		</Button>
	);
}
